import { memo, useState } from "react";
import {
  ThemedContentCopyIcon,
  ThemedCheckCircleIcon,
} from "assets/CXFIcons/Designer/ContextActions";
import ContextHeaderButton from "../ContextHeaderButton";

const CopyButton = ({ editorRef }) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleCopy = () => {
    if (editorRef.current) {
      const editor = editorRef.current;
      const content = editor.getValue();

      navigator.clipboard
        .writeText(content)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        })
        .catch((error) => {
          console.error("Error copying text to clipboard:", error);
        });
      
    }
  };

  return (
    <ContextHeaderButton
      icon={isCopied ? <ThemedCheckCircleIcon /> : <ThemedContentCopyIcon />}
      label={isCopied ? "Copied" : "Copy"}
      action={handleCopy}
      disabled={isCopied}
    />
  );
};

export default memo(CopyButton);
